module.exports = __webpack_public_path__ + "static/img/home_new9.7da50740.jpg";